import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHailuoAiVideoGeneratorConfig } from '@/data/landingConfig/landingHailuoAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HailuoAiVideoGenerator } from './schemaObject';

interface Props {}
const HailuoAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HailuoAiVideoGenerator} />
			<LandingTemplate
				data={landingHailuoAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default HailuoAiVideoGenerator;
